module.exports = {"extras":{"modem":{"title":"Gigabit WiFi-6 MESH 1800Mbps Modem","priceLarge":"FREE","monthlyPrice":0,"upfrontPrice":0,"deliveryFee":20,"priceSmall":"(Shipping fee applicable)","leadCopy":"The Exetel ZTE modem provides full remote diagnostics and support for your nbn™ service.","image":"/images/modem.png","imageSmall":"/images/modem-small.png","desc":"Easy set-up. Plug & play.","list":["EasyMesh standard to provide whole home Wi-Fi coverage","Sleek styling that blends perfectly with your home"]}}}


//////////////////
// WEBPACK FOOTER
// ./resources/data/flip-to-fibre/nbn-extras.json
// module id = L250
// module chunks = 0